import logo from "../../assets/images/logo.png"
import Web3Modal from "web3modal";
import Web3 from "web3";
import { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import WalletConnectProvider from "@walletconnect/web3-provider";

export default function Header({setUser}) {

    const [account , setAccount] = useState("");
    const [isConnected, setIsConnected] = useState(false);
    let web3Modal;

    async function connect() {
        

        const providerOptions = {
            walletconnect: {
                package: WalletConnectProvider,
                options: {
                  rpc: {
                    56: "https://bsc-dataseed1.defibit.io/",
                  },
                  chainId: 56,
                },
              },
        };

        web3Modal = new Web3Modal({
            network: "binance", // optional
            cacheProvider: true, // optional
            providerOptions // required
        });
        
        

        const provider = await web3Modal.connect();

        const web3 = new Web3(provider);
        const accounts = await web3.eth.getAccounts();
        const chainID = await web3.eth.getChainId();
        if(chainID !== 56) {
            toast.error("Please connect to Mainnet");
            return;
        }
        const data={
            account: accounts[0],
            isConnected: true,
            chainID: chainID,
            web3: web3,
            connect: connect
        }
        setUser(data)
        setAccount(accounts[0]);
        setIsConnected(true);
        toast.success("Successfully Connected");



    }  

    function abbreviateWallet(address){
        return address.substring(0,2) + "..." + address.substring(address.length-2,address.length);

    }

    useEffect(()=>{
        connect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);



    return (
        <header>
            <div className="info fade-in">
                <img src={logo} alt="" className="main-logo" />
                <button className="button-design" onClick={()=>{
                    if(!isConnected){
                        connect();
                    }
                    else{
                        setIsConnected(false);
                        setUser({account: "", isConnected: false, chainID: "", web3: "", connect: connect});
                        localStorage.clear();
                        try{
                            web3Modal.clearCachedProvider();

                        }
                        catch{

                        }
                    }
                }}>{!isConnected ? "Connect" : "Disconnect ("+abbreviateWallet(account)+")"}</button>
                <p className="desc">The Ultimate BNB reward Pool with the highest daily return and lowest fee.
</p>
            </div>
        </header>
    )
}